module.exports = __webpack_public_path__ + "static/media/zm.402266a0.svg";